import { FC } from 'react';
import { AvatarPlaceholder } from 'shared/icons';

interface AvatarProps {
  url: string;
}

export const Avatar: FC<AvatarProps> = ({ url }) => {
  return (
    <div className="h-[50px] w-[50px] overflow-hidden rounded-full bg-lightBlue">
      {url ? (
        <img alt="User placeholder" className="h-full w-full object-cover" src={url} />
      ) : (
        <AvatarPlaceholder />
      )}
    </div>
  );
};
